import moment from 'moment';
import { defaultDateFormat } from '../constants/dateFormats';
import React from 'react';

export const isEndDateInvalid = (startDate: string, endDate: string) => {
  //convert to utc to avoid issues on using the system timezone to convert string formatted date
  const newStartDateMoment = moment.utc(startDate, defaultDateFormat);
  const currentEndDateMoment = moment.utc(endDate, defaultDateFormat);
  return currentEndDateMoment.isBefore(newStartDateMoment);
};

/**
 * Handles the change event for time and date pickers by toggling the updating state
 * and invoking a callback function.
 *
 * @param isUpdating - React state resembling if the current time/date picker is being updated
 * @param setIsUpdating - A React state setter function for a boolean value indicating whether the component is updating.
 * @param valueChangeCallbackFn - A callback function to be executed after the updating state is toggled.
 */
export const handleTimeAndDatePickerChange = (
  isUpdating: boolean,
  setIsUpdating: React.Dispatch<React.SetStateAction<boolean>>,
  valueChangeCallbackFn: () => void,
) => {
  if (!isUpdating) {
    setIsUpdating(true);
  }
  valueChangeCallbackFn();
};
